const mounted = new Map();
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function showPopup(dialog, trigger) {
  if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
  const details = trigger?.closest('[data-dear-v-menu]');
  dialog.dearVReturnFocus = details?.querySelector('summary') || trigger || document.activeElement;
  if (details) details.open = false;
  dialog.showModal();
}
function mount(scope = document) {
  for (const dialog of scope.querySelectorAll('[data-dear-v-popup]')) {
    if (mounted.has(dialog)) continue;
    const controller = new AbortController();
    const signal = controller.signal;
    const key = 'dear-v-format-selector-' + dialog.dataset.sectionId;
    let timer;
    const remember = () => {
      try { localStorage.setItem(key, String(Date.now())); } catch {}
    };
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-dear-v-popup-close]')) dialog.close();
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    }, { signal });
    dialog.addEventListener('close', () => {
      remember();
      const trigger = dialog.dearVReturnFocus;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    }, { signal });
    let lastShown = 0;
    try { lastShown = Number(localStorage.getItem(key) || 0); } catch {}
    const repeat = Number(dialog.dataset.repeat || 7) * 86400000;
    if (dialog.dataset.auto === 'true' && !window.Shopify?.designMode && Date.now() - lastShown > repeat) {
      timer = window.setTimeout(() => {
        if (dialog.isConnected && !document.querySelector('dialog[open]') && !document.hidden) showPopup(dialog);
      }, Number(dialog.dataset.delay || 30) * 1000);
    }
    mounted.set(dialog, () => { controller.abort(); clearTimeout(timer); if (dialog.open) dialog.close(); });
  }
  for (const region of scope.querySelectorAll('[data-dear-v-announcements]')) {
    if (mounted.has(region)) continue;
    const slides = Array.from(region.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) continue;
    const controller = new AbortController();
    const signal = controller.signal;
    const previous = region.querySelector('[data-announcement-previous]');
    const next = region.querySelector('[data-announcement-next]');
    const pause = region.querySelector('[data-announcement-pause]');
    let index = 0;
    let paused = region.dataset.autoplay !== 'true' || reducedMotion.matches;
    let interval;
    const display = (value) => {
      index = (value + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
    };
    const refresh = () => {
      clearInterval(interval);
      pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      if (region.closest('[data-dv-art-direction="r10"]')) {
        pause.firstElementChild.innerHTML = paused
          ? '<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false"><path d="M4 2.5v11L13 8z"/></svg>'
          : '<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false"><path d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
      } else {
        pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }
      if (!paused) interval = setInterval(() => {
        if (!document.hidden && !region.matches(':hover') && !region.contains(document.activeElement)) display(index + 1);
      }, Number(region.dataset.interval || 8) * 1000);
    };
    previous.hidden = next.hidden = pause.hidden = false;
    previous.addEventListener('click', () => { display(index - 1); refresh(); }, { signal });
    next.addEventListener('click', () => { display(index + 1); refresh(); }, { signal });
    pause.addEventListener('click', () => { paused = !paused; refresh(); }, { signal });
    region.addEventListener('dear-v:select-announcement', (event) => { paused = true; display(slides.indexOf(event.detail)); refresh(); }, { signal });
    refresh();
    mounted.set(region, () => { controller.abort(); clearInterval(interval); });
  }
  for (const sticky of scope.querySelectorAll('[data-dear-v-sticky]')) {
    if (mounted.has(sticky)) continue;
    if (sticky.closest('[data-dv-art-direction="r10"]')) continue;
    const hero = document.querySelector('[data-mte-anchor="mte-pdp"]') || document.getElementById('mte-pdp');
    if (!hero) continue;
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    });
    observer.observe(hero);
    mounted.set(sticky, () => observer.disconnect());
  }
}
function findAnchor(hash) {
  if (!hash.startsWith('#mte-')) return null;
  const aliases = { 'mte-reviews': 'mte-live-reviews', 'mte-customer-reviews': 'mte-live-reviews', 'mte-ingredients': 'mte-ing' };
  let key;
  try { key = decodeURIComponent(hash.slice(1)); } catch { return null; }
  return document.getElementById(key) || Array.from(document.querySelectorAll('[data-mte-anchor]')).find((element) => element.dataset.mteAnchor === (aliases[key] || key));
}
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-dear-v-popup-open]');
  if (trigger) {
    event.preventDefault();
    showPopup(document.querySelector('[data-dear-v-popup]'), trigger);
    return;
  }
  const link = event.target.closest('a[href]');
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || url.searchParams.get('view') !== new URL(location.href).searchParams.get('view')) return;
  const anchor = findAnchor(url.hash);
  if (!anchor) return;
  event.preventDefault();
  for (const menu of document.querySelectorAll('[data-dear-v-menu][open]')) menu.open = false;
  anchor.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
  history.replaceState(null, '', url.hash);
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('[data-dear-v-menu][open]')) {
    menu.open = false;
    menu.querySelector('summary')?.focus({ preventScroll: true });
  }
});
document.addEventListener('shopify:section:load', (event) => mount(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const [element, destroy] of mounted) if (event.target.contains(element)) { destroy(); mounted.delete(element); }
});
document.addEventListener('shopify:block:select', (event) => {
  const dialog = event.target.closest('[data-dear-v-popup]') || event.target.querySelector('[data-dear-v-popup]');
  if (dialog) showPopup(dialog);
  const slide = event.target.closest('[data-announcement-slide]');
  if (slide) slide.closest('[data-dear-v-announcements]')?.dispatchEvent(new CustomEvent('dear-v:select-announcement', { detail: slide }));
});
function scrollInitialAnchor() {
  findAnchor(location.hash)?.scrollIntoView({ behavior: 'instant', block: 'start' });
}
if (document.readyState === 'complete') scrollInitialAnchor();
else window.addEventListener('load', scrollInitialAnchor, { once: true });
mount();
